import { Box, type BoxT } from '@mentimeter/ragnar-ui/box';
import { alpha } from '@mentimeter/ragnar-colors';

export const FullSizeBackground = ({
  backgroundImage,
  backgroundImageSize,
  shouldShowColorOverlay,
  enableAnimations,
  altText,
  ...props
}: BoxT & {
  backgroundImage: string;
  backgroundImageSize: string | 'cover' | 'contain';
  enableAnimations?: boolean | undefined;
  shouldShowColorOverlay?: boolean | undefined;
  altText: string;
}) => {
  return (
    <Box
      role="img"
      aria-label={altText}
      width="100%"
      height="100%"
      data-testid="content-image-full-size"
      extend={({ theme }) => ({
        backgroundImage: shouldShowColorOverlay
          ? `linear-gradient(
              ${alpha(theme.colors.bg, theme.backdropAlpha ?? 1)},
              ${alpha(theme.colors.bg, theme.backdropAlpha ?? 1)}
              ), url(${backgroundImage})`
          : `url(${backgroundImage})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: backgroundImageSize || 'cover',
      })}
      {...props}
    />
  );
};
